/*eslint no-useless-constructor: "error"*/
"use strict";
import { paddingLeftByStr } from "@/utils";

export class MemberModel {
  constructor(json) {
    this.init();
    if (json) {
      this.initWithJson(json);
    }
  }
  init() {
    this.memberId = null;
    this.username = "";
    this.password = "";
    this.email = "";
    this.firstName = "";
    this.lastName = "";
    this.nickName = "";
    this.role = "";
    this.sex = "";
    this.birthday = "";
    this.birthdayYear = null;
    this.birthdayMonth = null;
    this.birthdayDay = null;
    // this.emailVerified = false;
    this.sendVerifyTime = null;
    this.verifiedCode = null;
    this.emailVerifiedTime = null;
    this.subscription = false;
    this.status = 0;
  }
  initWithJson(json) {
    this.memberId = json["memberId"];
    this.username = json["username"];
    // this.password = json["password"];
    this.email = json["email"];
    this.firstName = json["firstName"];
    this.lastName = json["lastName"];
    this.nickName = json["nickName"];
    this.role = json["role"];
    this.sex = json["sex"];
    this.birthday = json["birthday"];
    if (this.birthday && this.birthday !== "") {
      const birthdaySplit = this.birthday.split("/");
      this.birthdayYear = parseInt(birthdaySplit[0]);
      this.birthdayMonth = parseInt(birthdaySplit[1]);
      this.birthdayDay = parseInt(birthdaySplit[2]);
    }
    // this.emailVerified = json["emailVerified"];
    this.sendVerifyTime = json["sendVerifyTime"];
    this.verifiedCode = json["verifiedCode"];
    this.emailVerifiedTime = json["emailVerifiedTime"];
    this.subscription = json["subscription"];
    this.status = json["status"];
  }
  get registerJson() {
    return {
      "username": this.email,
      "password": this.password,
      "email": this.email,
      "firstName": this.firstName,
      "lastName": this.lastName,
      "nickName": this.nickName,
      "role": this.role,
      "sex": this.sex,
      "birthday": `${this.birthdayYear}/`+
        `${paddingLeftByStr('0', (this.birthdayMonth + 1).toString(), 2)}/` +
        `${paddingLeftByStr('0', (this.birthdayDay + 1).toString(), 2)}`
    }
  }
}
